import React from 'react';
import { Box, Copy, Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import RoutableSitecoreLink from '../../RoutableSitecoreLink';
import formatDealerAddress from '../../../utils/formatDealerAddress';
import { useLanguage, useAppName } from '../../../utils/sitecoreContext';
import formatNumber from '../../../utils/formatNumber';
import themeStyles from './DealerCard.styles';
import { useAppSelector } from '../../../core/utils';
import { DEALER_DEPARTMENT_TYPE } from '../../../utils/constants';
import gtmDealerCardCtaClick from '../../../core/gtm/gtmDealerCardCtaClick';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
const floorParser = (num) => Math.floor(num * 10) / 10;
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const AddressWrapper = themeStyles.apply(Box, 'AddressWrapper');
const HeaderWrapper = themeStyles.apply(Box, 'HeaderWrapper');
const DealerName = themeStyles.apply(Copy, 'DealerName');
const Distance = themeStyles.apply(Copy, 'Distance');
const Address = themeStyles.apply(Copy, 'Address');
const CTA = themeStyles.apply(Button, 'CTA');
const DealerCard = ({ dealer, distance, isCardSelected, fields, handleDealerCardClick, handleDealerCardMouseEnter, handleDealerCardMouseLeave, setDealerCookie, ctaLabel, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const appName = useAppName();
    const { name, location, departments } = dealer !== null && dealer !== void 0 ? dealer : {};
    const componentName = fields === null || fields === void 0 ? void 0 : fields.componentName;
    const nextStepUrl = (_d = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.nextStepBaseUrl) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.value;
    const queryString = fields === null || fields === void 0 ? void 0 : fields.ctaQueryString;
    const { linktype, href } = nextStepUrl !== null && nextStepUrl !== void 0 ? nextStepUrl : {};
    const { t } = useTranslation();
    const language = useLanguage();
    const distanceAway = formatNumber(distance, language, 1, floorParser);
    const dealerAddress = formatDealerAddress(location);
    // get dealer sales department detail
    const salesDepartment = departments === null || departments === void 0 ? void 0 : departments.find(department => (department === null || department === void 0 ? void 0 : department.type) === DEALER_DEPARTMENT_TYPE);
    const dealerContact = ((_e = salesDepartment === null || salesDepartment === void 0 ? void 0 : salesDepartment.contactInformation) === null || _e === void 0 ? void 0 : _e.phone) || '';
    const dealerEmail = ((_f = salesDepartment === null || salesDepartment === void 0 ? void 0 : salesDepartment.contactInformation) === null || _f === void 0 ? void 0 : _f.email) || '';
    const dealerWebsite = ((_g = salesDepartment === null || salesDepartment === void 0 ? void 0 : salesDepartment.contactInformation) === null || _g === void 0 ? void 0 : _g.website) || '';
    const { modelKey } = useAppSelector(selectCurrentVehicle);
    const handleCtaClick = (evt) => {
        evt.stopPropagation();
        gtmDealerCardCtaClick({
            model: modelKey,
            linkUrl: `${href}?${queryString}`,
            componentType: componentName,
            dealerName: dealer === null || dealer === void 0 ? void 0 : dealer.name,
        });
        setDealerCookie({
            dealerCode: dealer === null || dealer === void 0 ? void 0 : dealer.code,
            dealerName: dealer === null || dealer === void 0 ? void 0 : dealer.name,
            dealerContact,
            dealerEmail,
            dealerWebsite,
            dealerAddress,
            dealerDistance: distance,
            evDealer: dealer === null || dealer === void 0 ? void 0 : dealer.evDealer,
        });
    };
    return (React.createElement(Wrapper, { "data-testid": "cy-dealer-card", onClick: handleDealerCardClick, onMouseEnter: handleDealerCardMouseEnter, onMouseLeave: handleDealerCardMouseLeave, isSelected: isCardSelected, variant: appName },
        React.createElement(AddressWrapper, null,
            React.createElement(HeaderWrapper, null,
                React.createElement(DealerName, { size: "subheading", "data-testid": "cy-dealer-name" }, name),
                !!distance && (React.createElement(Distance, { "data-testid": "cy-dealer-distance" }, t('Sub-apps.Dealers.kmAwayLabel', { KMValue: distanceAway })))),
            React.createElement(Address, { size: "small", "data-testid": "cy-dealer-address" }, dealerAddress)),
        React.createElement(CTA, { styling: "primary", onClick: handleCtaClick, as: RoutableSitecoreLink, field: {
                value: {
                    linktype,
                    href,
                    querystring: queryString,
                },
            } }, ctaLabel)));
};
export default DealerCard;
